const setState = (key) => (state, payload) => {
  state[key] = payload
}

const setStateById = (key) => (state, payload) => {
  state[key][payload.id] = payload
}

export { setState, setStateById }
